import ReactDOM from "react-dom";
import moment, { isDate } from "moment";
import { courtTypesByState } from "../../utils/courtTypes";
import { acdCodes } from "../../utils/acdCodes";
import { useRef, useState } from "react";
import PostConviction from "./postConviction";
import { canadianProvinces } from "../../utils/countryOptions";
import {defaultDriverData, makeWithdrawalObjectForAdd, errMessage,
    postJson, toYMD, foreignData,  buildSource,
    isCDLHolder} from "../../utils/data";
//import UpdateDriver from "./updatedriver";
import { useNavigate, useParams } from "react-router-dom";
import { formatDOB, validateDate } from "../../components/consts/dateMask"
import StateSel from "./selectQueries/stateSel.js";

import DatePicker from 'react-datepicker';
import { getYear, getMonth, addDays, subDays, setHours, setMinutes } from "date-fns";
import 'react-datepicker/dist/react-datepicker.css';
import { suffix } from "../../utils/withdrawalOptions";
import { useAuth } from "../../context/AuthContext.js";
const defined = (v) => v !== undefined && v !== null && v !== "";

function AddConvictions() {
    const {source, token, userState, email, roles} = useAuth();
    const { jurisdiction, license } = useParams();
 
    const defaults = {
        "courtType"     : "",
        "addCode"       : "",
        "selectedAcd"   : "",
        "cmvCode"       : "",
        "hazMat"        : "",
        "maxval"        : "",
        "userCourtType" : "",
        "convictionDate" : "",
        "citationDate"   : "",
        "convOff"        : "",
        "stateNative"    : "",
        "comments"       : "Conviction Added",
        "acdDetail"      : "",
        "state"          : "AK"

    }

    const acdDetailsRef = useRef(null);
    //const navigate = useNavigate();
    const [formData, setFormData] = useState(defaults);
    const [courtType, setCourtType] = useState("");
    const [acdCode, setAcdCode] = useState("");
    const [selectedAcd, setSelectedAcd] = useState(null);
    const [cmvCode, setCmvCode] = useState("");
    const [hazMat, setHazMat] = useState("");
    const [acdDetail, setAcdDetail] = useState("");
    const [maxVal, setMaxVal] = useState(0);
    const [ dateErr, setDateErr ] = useState([])
    const [validated, setValidated] = useState(false);
    const saver = useRef(null);
    const warnRef = useRef(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
    const [err, setErr] = useState([]);
    const [locked, setLocked] = useState(false)

    const navigate = useNavigate();
    const userCourtType = "DEFAULT"; // Replace with actual user state logic
    const defined = (v) => v !== undefined && v !== null && v !== "";
    const acdDet = ['A11', 'A91', 'D45', 'D53', 'D56', 'S92'];
    const acdOther = ['A04','A94','U07','U08','U09','U10','B91','M85','M86'];
    const acdMajor = ['A04', 'A94', 'U07', 'U08', 'U09', 'U10'];
    const acdSerious = ['B91', 'M85', 'M86'];
    const isHelp = "HelpDesk"

    let isCanada = false;

    let cdl = "9";

    if(isCDLHolder === true){
        cdl = "1";
    } 

    if(isCDLHolder === false){
        cdl = "2"
    }

    let useDriver = {};

    if(!defined(defaultDriverData.dob)){
            useDriver = foreignData;
        } else {
            useDriver = defaultDriverData;
        }

    
    console.log("DDD: "+JSON.stringify(useDriver))
    canadianProvinces.forEach((v) => {
        if(jurisdiction === v.code){
            isCanada = true;
        }
    })


    //console.log(JSON.stringify(foreignData))
    //alert(JSON.stringify(useDriver))


    //console.log(JSON.stringify(defaultDriverData))

  const handleButtonClick = () => {
    setIsDatePickerOpen(!isDatePickerOpen); // Toggle visibility
  };

  const disableKey  = (event) =>{ 
        event.preventDefault();
        const { name, value } = event.target;
        if(formatDOB(value)){
            return;
        }
        setFormData((formData) => ({ ...formData, [name]: 0 }));
  }

  const handleDateChange = (date) => {

    setSelectedDate(date);
    setIsDatePickerOpen(false); // Close after selection
  };
    const convertDate = (d) =>{


        if (!defined(d)) return undefined;
        // If already "YYYYMMDD", return as-is:
        if (typeof d === "string" && /^\d{8}$/.test(d)) return d;
        try {
            const dt = new Date(d);
            const y = dt.getFullYear();
            const m = String(dt.getMonth() + 1).padStart(2, "0");
            const day = String(dt.getDate()).padStart(2, "0");
            return `${y}${m}${day}`;
        } catch {
            return undefined;
  }
    };

    const cleanDate = (d) => {
        if(d === undefined){
            return;
        }
        if(d.includes("-")){
            return d.replace(/-/g, ""); 
        } else {
            return d;
        }
    }

    const handleChange = (event) =>{
        const { name, value } = event.target;

        if(hazMat === "1"){
            setCmvCode("1");
        }


        setFormData((formData) => ({ ...formData, [name]: value }));

    }
    const  handleCancel = (e) => {
        e.preventDefault();
        navigate(-1);
    }

    const checkACD = (e) => {
        if(acdDetail !== ""){
            setAcdDetail("");
        }
    }

   const handleAcdChange = (e) => {
        const code = e.target.value;
        setAcdCode(code);
        if (acdDetailsRef.current) {
            acdDetailsRef.current.value = "";
        }
        acdDet.includes(code)//"S92"
            ? setMaxVal(5)
            : code.startsWith("D")
                ? setMaxVal(3)
                : setMaxVal(2);
        const found = acdCodes.find((a) => a.code === code);
        setSelectedAcd(found || null);
    };


    const handleSubmit = async (e) => {

        e.preventDefault();
        let errs = [];
        setDateErr(err);
        const form = e.target;


        validateDate(formData.citationDate, false, errs);
        validateDate(formData.convictionDate, false, errs);

        if(!isCDLHolder && (cmvCode !== "1")){
            errs.push("NON CDLIS CONVICTION")
        }
        if(defined(acdDetail.code)){
            if(acdDetail.includes(".")){
                if(setAcdCode.code.startsWith("A")){
                    errs.push(selectedAcd.code+" ACD CONV CODE VALUE REQUIRES BLANK CONV OFF DET FOR ACD CONV CODE:")
                }
            }
        }

        if(cmvCode === 1){
            setHazMat(1)
        }



        //const source = buildSource(foreignData);
        let dobMatch = "yes";
        let nameMatch = "yes";
        let isDown = "no";

        if(cleanDate(source.dob) !== cleanDate(useDriver.dob)) {
            console.log("DOB different")
            dobMatch="no"
        }

        if((source.surName && useDriver.surName !== source.surName) ||
            (source.suffix && useDriver.suffix !== source.suffix) ||
            (source.middleName && useDriver.middleName !== source.middleName) ||
            (source.firstName && useDriver.firstName !== source.firstName)
        ){
            console.log("Name different")
            nameMatch="no"
        }

        if(!defined(acdDetailsRef?.current)){
            setAcdDetail("")
         }
/*
        alert(cleanDate(formData.citationDate) + " : " + 
        cleanDate(formData.convictionDate))
*/
        setValidated(true)

        if(selectedAcd === null){
            return;
        }

        if(errs.length > 0){
            setErr(errs);
            return;
        }

       let entry = "";
       //alert(defaultDriverData.dob)

        if (form.checkValidity() === false) {
            e.stopPropagation(); // prevent submit if invalid
            return;
        }


        if(hazMat === "1"){
            setCmvCode("1");
        }

    if(defined(roles)){
       if(roles.includes("fcwdHelpDesk")){
      
        entry = {
                "Header": {
                    "Metadata": {
                        "UserID": email
                    }
                },
                "Body": {//this request adds a new conviction(if not duplicate) and review records(One for CAorMXdown, one for Name mismatch and another for DOB mismatch, And, one for Conviction is Major, Serious, RRHGC, VOOSO...due to B27 ACD code).
                    "Source":{
                        "DataSource": source,
                        "CAorMXDown": isDown, //(Yes or No); Choose Yes when Status response has "Canada is Currently Unavailable" or "Mexico eLicencia is currently unavailable"  
                        "NameMatched":nameMatch, //(Yes or No) if No, need to send SourceNameObj(foreign data received from MX or Canada) and ReqNameObj(Jurisdiction data from request) name objects in UnMatchedData else don't send name fields in UnMatchedData object. The value is Yes when matched or if record is not found.
                        "DOBMatched": dobMatch //(Yes or No) if No, need to send SourceDob(foreign data) and ReqDob(Jurisdiction data from request) values in UnMatchedData else don't send DOB fields in UnMatchedData object. The value is Yes when matched or if record is not found.
                    },
                    "PersonDetails": {
                        "PersonName": {
                            "SurName": useDriver?.surName,
                            "FirstName": useDriver?.firstName,
                            "MiddleName": useDriver?.middleName,
                            "Suffix": useDriver?.suffix
                        },
                        "PhysicalDetails": {
                            "Sex": useDriver?.sex
                        },
                        "DOB":  cleanDate(useDriver.dob),
                        "SSN":  useDriver?.ssn,
                        "MailingAddress": {
                            "Line1": useDriver?.street1,
                            "Line2": useDriver?.street2,
                            "City": useDriver?.city,
                            "State": useDriver?.state,
                            "Zip": useDriver?.zip,
                            "County": useDriver?.county,
                            "Country": useDriver?.country
                        }
                    },
                    "License": {
                        "JurisdictionOfIssue": jurisdiction,
                        "LicenseNumber": license
                    },
                    "Convictions": {
                        "JurisdictionCodeConvicting": formData.state,
                        "CitationDate": cleanDate(formData.citationDate),
                        "ConvictionDate": cleanDate(formData.convictionDate),
                        "ConvictionCourtType": courtType,
                        "ConvictionCommercialVehInd": cmvCode,
                        "ConvictionHazmatInd": hazMat,
                        "CDLIndicator": cdl, //"1",
                        "ConvictionJurisCourtReportId": formData.convOff,
                        "ConvictionJurisdictionOffenseCode": formData.stateNative,
                        "ConvictionOffenseAcdCode": selectedAcd.code,
                        "ConvictionOffenseDetailAcd": acdDetail,
                        "ConvictionStatusNotes": formData.comments,
                        "ConvictionUserId": email //sessionStorage.getItem('email')
                    },
                    "UnMatchedData":{  //if NameMatched and DOBMatched values are Yes, then send an empty object as UnMatchedData : {}
                        "SourceNameObj": { //if NameMatched is Yes, these Name fields are not reviewed for changes
                            "SurName": foreignData?.surName,
                            "FirstName": foreignData?.firstName,
                            "MiddleName": foreignData?.middleName,
                            "Suffix": foreignData?.suffix
                        },
                        "ReqNameObj": {
                            "SurName": useDriver?.surName,
                            "FirstName": useDriver?.firstName,
                            "MiddleName": useDriver?.middleName,
                            "Suffix": useDriver?.suffix
                        },
                        "DOBObject": {  //if DOBMatched is Yes, these DOB fields are not reviewed for changes
                            "SourceDob": foreignData.dob,
                            "ReqDob": useDriver.dob
                        }
                    }
                }
            }
         }   else {
   
            entry = {
                "Header": {
                    "Metadata": {
                        "UserID": email,
                    }
                },
                "Body": {
                    "Source":{
                        "DataSource": source,
                        "CAorMXDown": isDown
                    },
                    "PersonDetails": {
                        "PersonName": {
                            "SurName": useDriver?.surName,
                            "FirstName": useDriver?.firstName,
                            "MiddleName": useDriver?.middleName,
                            "Suffix": useDriver?.suffix
                        },
                        "PhysicalDetails": {
                            "Sex": useDriver?.sex,
                        },
                        "DOB": cleanDate(useDriver.dob),
                        "SSN": useDriver?.ssn,
                        "MailingAddress": {
                            "Line1": useDriver?.street1,
                            "Line2": useDriver?.street2,
                            "City": useDriver?.city,
                            "State": useDriver?.state,
                            "Zip": useDriver?.zip,
                            "County": useDriver?.county,
                            "Country": useDriver?.country
                        }
                    },
                    "License": {
                        "JurisdictionOfIssue": jurisdiction,
                        "LicenseNumber": license
                    },
                    "Convictions": {
                        "JurisdictionCodeConvicting": userState,
                        "CitationDate": cleanDate(formData.citationDate),
                        "ConvictionDate": cleanDate(formData.convictionDate),
                        "ConvictionCourtType": courtType,
                        "ConvictionCommercialVehInd": cmvCode,
                        "CDLIndicator": cdl, //"1",
                        "ConvictionHazmatInd": hazMat,
                        "ConvictionJurisCourtReportId": formData.convOff,
                        "ConvictionJurisdictionOffenseCode": formData.stateNative,
                        "ConvictionOffenseAcdCode": selectedAcd.code,
                        "ConvictionOffenseDetailAcd": acdDetail,
                        "ConvictionStatusNotes": formData.comments,
                        "ConvictionUserId": email
                    }
                }
            }

        }
    }

    console.log(JSON.stringify(entry))


        try {    
            ReactDOM.render(<PostConviction data={entry} auth={token}/>,
                saver.current); 
        } catch(err){
            alert(err)
        }
        
    };


    return (
        <>
            <div className="App">
                <div ref={saver}></div>
                <div>{errMessage}</div>
                <h1>Add Conviction</h1>
                <div style={{color: "red"}}>{err}</div>
                <div id="table" ref={warnRef}>
                    <form
                        className={`needs-validation ${validated ? "was-validated" : ""}`}
                        id="Index-form"
                        noValidate
                        onSubmit={handleSubmit}
                    >
                        <div className="row">
                            <div className="col-md-5">
                                <label className="form-label">
                                    <b>Driver State</b>
                                </label>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="TX"
                                    value={jurisdiction}
                                    disabled
                                />
                            </div>
                            <div className="col-md-5">
                                <label className="form-label">
                                    <b>Driver License</b>
                                </label>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Test1234"
                                    value={license}
                                    disabled
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3">
                                <label className="form-label">
                                    <b><span className="text-danger">*</span>Citation Date</b>
                                </label>
                                {hazMat === "h9" || cmvCode === "c9" ? (
                                    <><input
                                        type="date"
                                        className="form-control"
                                        name="citationDate"
                                        placeholder="MM/DD/YYYY"
                                        onKeyDown={(e) => disableKey(e)}
                                        max={moment("2007-12-31").format("YYYYMMDD")}
                                        required />
                                        
                                        <input type="date" className="form-control" 
                                            placeholder="MM/DD/YYYY"
                                            name="citationDate" 
                                           onChange={(e) => handleChange(e)}
                                            max={moment().format("YYYY-MM-DD")}
                                            onKeyDown={(e) => disableKey(e)}
                                            pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' 
                                        required />

                                        {hazMat === "h9" ? (
                                            <div className="invalid-feedback">CONV HAZ IND MUST = 1 OR 2, FOR CITATION DATE &gt; 200701231</div>
                                        ) : (
                                            <div className="invalid-feedback">CONV CMV IND MUST = 1 OR 2, FOR CITATION DATE &gt; 200701231</div>
                                        )}

                                    </>
                                    ) : (
                                        <>                                     
                                    <input type="date" className="form-control" 
                                            placeholder="MM/DD/YYYY"
                                            name="citationDate" 
                                            onChange={(e) => handleChange(e)}
                                            max={moment().format("YYYY-MM-DD")}
                                            onKeyDown={(e) => disableKey(e)}
                                            pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' 
                                        required />
                                    <div className="invalid-feedback">INVALID CITATION DATE</div>
                                    
                                    </>
                                )}
                                
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">
                                    <b><span className="text-danger">*</span>Conviction Date</b>
                                </label>
                                <input type="date" className="form-control" 
                                    placeholder="MM/DD/YYYY"
                                    name="convictionDate"
                                    onChange={(e) => handleChange(e)}
                                    max={moment().format("YYYY-MM-DD")}
                                    onKeyDown={(e) => disableKey(e)}
                                    pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' 
                                required />                                     
                                <div className="invalid-feedback">INVALID CONVICTION DATE</div>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">
                                    <b><span className="text-danger">*</span>Court Type:</b>
                                </label>
                                <select
                                    className="form-control form-select"
                                    required
                                    value={courtType}
                                    onChange={(e) => setCourtType(e.target.value)}
                                >
                                    <option value="" disabled>
                                        -- Court Type --
                                    </option>
                                    {courtTypesByState[userCourtType].map((opt) => (
                                        <option key={opt.code} value={opt.code}>
                                            {opt.label}
                                        </option>
                                    ))}
                                </select>
                                <div className="invalid-feedback">Please select a Court Type</div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3">
                                <label className="form-label">
                                     <span className="text-danger">*</span><b>ACD Code</b>
                                </label>
                                <select
                                    className="form-control form-select"
                                    onClick={(e)=>checkACD(e)}
                                    value={acdCode}
                                    onChange={handleAcdChange}
                                    required
                                >
                                    <option value="" disabled>
                                        -- ACD Code --
                                    </option>
                                    {acdCodes.map((opt) => (
                                        !opt.code.includes('W') && (
                                        <option key={opt.code} value={opt.code} title={opt.label}>
                                            {opt.code} - {opt.simple}
                                        </option>)
                                    ))}
                                </select>
                                <div className="invalid-feedback">Please select an ACD Code</div>

                                {selectedAcd && (
                                    <div className="mt-1">
                                        <span
                                            className="text-primary text-decoration-underline"
                                            role="button"
                                            data-bs-toggle="modal"
                                            data-bs-target="#acdInfoModal"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                fill="currentColor"
                                                className="bi bi-info-circle"
                                                viewBox="0 0 16 16"
                                            >
                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                                            </svg>
                                        </span>
                                    </div>
                                )}
                            </div>

                            <div className="col-md-5">
                                {selectedAcd ? (
                                    selectedAcd.required == null ? (
                                        <div>
                                        <label className="form-label"><b>ACD Details</b></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="acdDetails"
                                            value={""}
                                            readOnly
                                        /></div>
                                    ) : selectedAcd.required ? (
                                        <div>
                                            <label className="form-label">
                                                <span className="text-danger">*</span><b>ACD Details</b>
                                            </label>
                                            <input
                                                ref={acdDetailsRef}
                                                pattern="[A-Za-z0-9]*"
                                                type="text"
                                                className="form-control"
                                                name="acdDetail"
                                                maxLength={maxVal}
                                                value={acdDetail}
                                                onChange={(e) => setAcdDetail(e.target.value)}
                                                required
                                            />
                                            <div className="invalid-feedback">
                                                INVALID CONV OFF DETAIL FOR GIVEN ACD CONV CODE FOR ACD CONV CODE: {selectedAcd.code}
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <label className="form-label"><b>ACD Details</b></label>
                                        <input
                                            ref={acdDetailsRef}
                                            pattern="[A-Za-z0-9]*"
                                            type="text"
                                            className="form-control"
                                            name="acdDetail"
                                            maxLength={maxVal}
                                            value={acdDetail}
                                            onChange={(e) => setAcdDetail(e.target.value)}
                                        />
                                        </div>
                                    )
                                ) : (
                                    <div>
                                        <label className="form-label"><b>ACD Details</b></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="acdDetails"
                                        readOnly
                                    />
                                    </div>
                                )}
                            </div>
                            <div className="col">
                                <label className="form-label">
                                    <b><span className="text-danger">*</span>CMV</b>
                                </label>
                                <select
                                    className="form-control form-select"
                                    value={cmvCode}
                                    onChange={(e) => setCmvCode(e.target.value)}
                                    required
                                >{hazMat === "1" ? (
                                    <option value="2">1 – Yes</option>
                                     ): (
                                
                                    <><option value="" disabled>
                                                -- CMV --
                                            </option>
                                            <option value="1">1 – Yes</option>
                                            <option value="2">2 – No</option>
                                            <option value="9">9 – Unknown</option></>
                                )}
                                </select>
                                { hazMat === "h1" && (
                                    <div className="form-text">
                                    If the Hazmat is Yes, CMV must be Yes.
                                </div>)}
                                
                                <div className="invalid-feedback">Please select CMV</div>
                            </div>

                            <div className="col">
                                <label className="form-label">
                                    <b><span className="text-danger">*</span>Hazmat</b>
                                </label>
                                <select
                                    className="form-control form-select"
                                    value={hazMat}
                                    onChange={(e) => setHazMat(e.target.value)}
                                    required
                                >
                                    <option value="" disabled>
                                        -- Hazmat --
                                    </option>
                                    <option value="1">1 – Yes</option>
                                    <option value="2">2 – No</option>
                                    <option value="9">9 – Unknown</option>
                                </select>
                                <div className="invalid-feedback">Please select Hazmat</div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <label className="form-label">
                                    <b><span className="text-danger">*</span>Conviction Offense Locator</b>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="convOff"
                                    value={formData.convOff}
                                    onChange={(e) => handleChange(e)}
                                    maxLength={18}
                                    required
                                />
                                <div className="invalid-feedback">
                                    Please enter Conviction Offense Locator
                                </div>
                            </div>
                            <div className="col">
                                <label className="form-label">
                                    <b><span className="text-danger">*</span>State Native Code</b>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="stateNative"
                                    value={formData.stateNative}
                                    onChange={(e) => handleChange(e)}
                                    maxLength={8}
                                    required
                                />
                                <div className="invalid-feedback">
                                    Please enter State Native Code
                                </div>
                            </div>
                            <div className="col">
                                <label className="form-label">
                                    <b><span className="text-danger">*</span>Comments</b>
                                </label>
                                <textarea
                                    type="text"
                                    className="form-control"
                                    name="comments"
                                    value={formData.comments}
                                    onChange={(e) => handleChange(e)}
                                    maxLength={500}
                                    required
                                />
                                <div className="invalid-feedback">Please enter Comments</div>
                            </div>
                              <div>
                                    {roles && ( roles.includes("fcwdHelpDesk") ) &&   
                                <th><p>
                                    <label className="form-label"><span className="text-danger">*</span>State:</label>
                                    <StateSel handleChange={handleChange}   
                                    value={formData?.state}
                                    formData={formData} />
                                </p></th>
                                }
                                </div>
                        </div>

                        <button type="submit" className="btn btn-primary mt-3">
                            Add Conviction
                        </button>
                        <button type="button" onClick={(e) => handleCancel(e)} className="btn btn-secondary mt-3 ms-2">
                            Back to Details for DL:{license}
                        </button>
                    </form>
                </div>
            </div>

            {selectedAcd && (
                <div
                    className="modal fade"
                    id="acdInfoModal"
                    tabIndex="-1"
                    aria-labelledby="acdInfoModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="acdInfoModalLabel">
                                    ACD Code Information
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>
                                    <strong>ACD Code:</strong> {selectedAcd.code}
                                </p>
                                <p>
                                    <strong>Description:</strong> {selectedAcd.label}
                                </p>
                                {selectedAcd.validation && (
                                    <p>
                                        <strong>Validation:</strong> {selectedAcd.validation}
                                    </p>
                                )}
                                {selectedAcd.moreInfo && (
                                    <p>
                                        <strong>More Info:</strong> {selectedAcd.moreInfo}
                                    </p>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default AddConvictions;